import { z } from 'src/lib'
import { schemaEntityWithId } from 'src/types'

export const EtapaPermisoFields = {
    IdGrupo: 'idGrupo',
    PermisoTipo: 'permisoTipo'
} as const

export const EtapaViewFields = {
    CodSistema: 'codSistema',
    CodSistemaPrincipal: 'codSistemaPrincipal',
    NombreEtapa: 'nombre',
    DiasDuracion: 'diasDuracion',
    CostoBase: 'costoBase',
    CostoDiario: 'costoDiario',
    FormAsociado: 'formAsociado',
    Activo: 'activo',
    CodEtapaEstado: 'codEtapaEstado',
    DescEtapaEstado: 'descEtapaEstado',
    HexColorEtapaEstado: 'hexColorEtapaEstado',
    TipoEtapa: 'tipoEtapa',
    IdEtapaVirtual: 'idEtapaVirtual',
    Orden: 'orden',
    CoordenadaX: 'posX',
    CoordenadaY: 'posY',
    NombreSistema: 'nombreSistema',
    NombreSistemaPrincipal: 'nombreSistemaPrincipal',
    IdEtapaAnular: 'idEtapaAnular',
    PermiteAnularCreador: 'permiteAnularCreador',
    PermiteAnularActual: 'permiteAnularActual',
    Permisos: 'permisos'
} as const

export const EtapaPostFields = {
    CodSistema: 'codSistema',
    NombreEtapa: 'nombre',
    DiasDuracion: 'diasDuracion',
    CostoBase: 'costoBase',
    CostoDiario: 'costoDiario',
    FormAsociado: 'formAsociado',
    Activo: 'activo',
    CodEtapaEstado: 'codEtapaEstado',
    TipoEtapa: 'tipoEtapa',
    IdEtapaVirtual: 'idEtapaVirtual',
    Orden: 'orden',
    IdEtapaAnular: 'idEtapaAnular',
    PermiteAnularCreador: 'permiteAnularCreador',
    PermiteAnularActual: 'permiteAnularActual',
    Permisos: 'permisos'
} as const

export const EtapaPermisoPostFields = {
    IdGrupo: 'idGrupo',
    PermisoTipo: 'permisoTipo'
} as const

export const schemaEtapaPermisoViewDTO = z
    .object({
        [EtapaPermisoFields.IdGrupo]: z.number(),
        [EtapaPermisoFields.PermisoTipo]: z.number()
    })
    .merge(schemaEntityWithId)

export const schemaEtapaViewDTO = z
    .object({
        [EtapaViewFields.CodSistema]: z.number(),
        [EtapaViewFields.CodSistemaPrincipal]: z.number(),
        [EtapaViewFields.NombreEtapa]: z.string(),
        [EtapaViewFields.DiasDuracion]: z.number(),
        [EtapaViewFields.CostoBase]: z.number(),
        [EtapaViewFields.CostoDiario]: z.number(),
        [EtapaViewFields.FormAsociado]: z.string().nullable(),
        [EtapaViewFields.Activo]: z.boolean(),
        [EtapaViewFields.CodEtapaEstado]: z.number(),
        [EtapaViewFields.DescEtapaEstado]: z.string().nullable(),
        [EtapaViewFields.HexColorEtapaEstado]: z.string().nullable(),
        [EtapaViewFields.TipoEtapa]: z.string(),
        [EtapaViewFields.IdEtapaVirtual]: z.number(),
        [EtapaViewFields.Orden]: z.number(),
        [EtapaViewFields.NombreSistema]: z.string().nullable(),
        [EtapaViewFields.NombreSistemaPrincipal]: z.string().nullable(),
        [EtapaViewFields.IdEtapaAnular]: z.number().nullable(),
        [EtapaViewFields.PermiteAnularCreador]: z.boolean().nullable(),
        [EtapaViewFields.PermiteAnularActual]: z.boolean().nullable(),
        [EtapaViewFields.Permisos]: z.array(schemaEtapaPermisoViewDTO).nullable()
    })
    .merge(schemaEntityWithId)

const schemaEtapaPermisoPostDTO = z.object({
    [EtapaPermisoPostFields.IdGrupo]: z.number(),
    [EtapaPermisoPostFields.PermisoTipo]: z.number()
})

export const schemaEtapaPostDTO = z.object({
    [EtapaPostFields.CodSistema]: z.number(),
    [EtapaPostFields.NombreEtapa]: z.string(),
    [EtapaPostFields.DiasDuracion]: z.number(),
    [EtapaPostFields.CostoBase]: z.number(),
    [EtapaPostFields.CostoDiario]: z.number(),
    [EtapaPostFields.FormAsociado]: z.string().nullable(),
    [EtapaPostFields.Activo]: z.boolean(),
    [EtapaPostFields.CodEtapaEstado]: z.number(),
    [EtapaPostFields.TipoEtapa]: z.string(),
    [EtapaPostFields.IdEtapaVirtual]: z.number(),
    [EtapaPostFields.Orden]: z.number(),
    [EtapaPostFields.IdEtapaAnular]: z.number().nullable(),
    [EtapaPostFields.PermiteAnularCreador]: z.boolean(),
    [EtapaPostFields.PermiteAnularActual]: z.boolean(),
    [EtapaPostFields.Permisos]: z.array(schemaEtapaPermisoPostDTO).nullable()
})

export type EtapaPostDTO = z.infer<typeof schemaEtapaPostDTO>

export const EtapaRequestFields = {
    CodSistemaPrincipal: 'codSistemaPrincipal',
    CodSistema: 'codSistema',
    CodSistemaTipo: 'codSistemaTipo',
    Nombre: 'nombreEtapa'
} as const

export const schemaEtapaRequestDTO = z.object({
    [EtapaRequestFields.CodSistemaPrincipal]: z.number().optional(),
    [EtapaRequestFields.CodSistema]: z.number().optional(),
    [EtapaRequestFields.CodSistemaTipo]: z.number().optional(),
    [EtapaRequestFields.Nombre]: z.string().optional()
})

export type EtapaRequestDTO = z.infer<typeof schemaEtapaRequestDTO>
